<template>
	<HeadingX class="c-base-h3" v-bind="{ tag }" :level-offset="levelOffset">
		<template v-if="domProps.textContent">
			{{ domProps.textContent }}
		</template>
		<template v-else>
			<slot></slot>
		</template>
	</HeadingX>
</template>

<script>
import HeadingX from '~/components/shared/HeadingX';

export default {
	name: 'BaseH3',
	components: { HeadingX },

	props: {
		tag: {
			type: String,
			default: undefined,
		},
		levelOffset: {
			type: [Number, String],
			default: 2,
		},
	},

	computed: {
		domProps() {
			const { domProps } = this.$vnode?.data || {};
			return domProps || {};
		},
	},
};
</script>

<style lang="postcss">
:where(.c-base-h3) {
	@apply text-h3 font-normal whitespace-pre-wrap;
	text-wrap: balance;
}
</style>
